<template>
  <div>
    <form @submit.prevent="saveMenuGroup">
      <b-modal
        id="showModal"
        v-model="showModal"
        size="m"
        no-close-on-backdrop
        no-close-on-esc
        @shown="reset"
      >
        <div slot="modal-header" class="w-100">
          <font-awesome-icon icon="bars" />
          <span class="pl-2">
            {{ input ? 'Edit' : 'Add' }} Menu Group
          </span>
        </div>
        <div>
          <b-container fluid class="pt-4">
            <b-row class="mt-2">
              <b-col md="5">
                <label>Outlet Code</label>
              </b-col>
              <b-col md="7" :class="{'form-error': errors.first('outletCode')}">
                <b-form-input
                  v-model="obj.outletCode"
                  v-validate="'required|alpha_num'"
                  type="text"
                  name="outletCode"
                />
                <small>{{ errors.first('outletCode') }}</small>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col md="5">
                <label>Menu Group Code</label>
              </b-col>
              <b-col md="7" :class="{'form-error': errors.first('menuGroupCode')}">
                <b-form-input
                  v-model="obj.menuGroupCode"
                  v-validate="'required|alpha_num'"
                  type="text"
                  name="menuGroupCode"
                />
                <small>{{ errors.first('menuGroupCode') }}</small>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col md="5">
                <label>Sequence</label>
              </b-col>
              <b-col md="7" :class="{'form-error': errors.first('sequence')}">
                <b-form-input
                  v-model.number="obj.sequence"
                  v-validate="'required|numeric'"
                  type="number"
                  name="sequence"
                />
                <small>{{ errors.first('sequence') }}</small>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col md="5">
                <label>Menu Group Name</label>
              </b-col>
              <b-col md="7" :class="{'form-error': errors.first('name')}">
                <b-form-input v-model="obj.name" v-validate="'required'" type="text" name="name" />
                <small>{{ errors.first('name') }}</small>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col md="5">
                <label>Show on</label>
              </b-col>
              <b-col md="7">
                <b-form-checkbox v-model="obj.qdoDisplay" class="form-checkbox">
                  QDO
                </b-form-checkbox>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col md="5">
                <label>Is Active</label>
              </b-col>
              <b-col md="7">
                <b-form-checkbox v-model="obj.isActive" class="form-checkbox">
                  is Active
                </b-form-checkbox>
              </b-col>
            </b-row>
          </b-container>
        </div>
        <div slot="modal-footer" class="w-100">
          <b-btn type="submit" variant="success">
            <font-awesome-icon icon="save" />
            {{ input ? 'Update' : 'Save' }} Data
          </b-btn>
          <b-btn class="float-right" variant="danger" @click="discardModal">
            <font-awesome-icon icon="times" />Discard
          </b-btn>
        </div>
      </b-modal>
    </form>
  </div>
</template>

<script>
import { getResponseToMTH } from '@/utils/helpers';
import constants from '@/utils/constants';

export default {
  props: {
    input: {
      type: null,
      default: null
    },
    showModal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      obj: {}
    };
  },
  methods: {
    // add and update records
    saveMenuGroup() {
      this.$validator.validate().then(valid => {
        if (valid) {
          if (this.input === null) {
            this.$store
              .dispatch('CreateMenuGroup', this.obj)
              .then(response => {
                let res = getResponseToMTH(
                  response,
                  this.$swal,
                  'Record is created'
                );
                if (res) {
                  this.$emit('discard-modal', true);
                  this.reset();
                }
              })
              .catch(error => {
                this.$swal(
                  constants.SOMETHING_WROING,
                  error.response.data.message,
                  constants.STATUS_ERROR
                );
              });
          } else {
            this.$store
              .dispatch('UpdateMenuGroup', this.obj)
              .then(response => {
                let res = getResponseToMTH(
                  response,
                  this.$swal,
                  constants.RECORD_IS_UPDATED
                );
                if (res) {
                  this.$emit('discard-modal', true);
                  this.reset();
                }
              })
              .catch(error => {
                this.$swal(
                  constants.SOMETHING_WROING,
                  error.response.data.message,
                  constants.STATUS_ERROR
                );
              });
          }
        }
      });
    },
    discardModal() {
      this.reset();
      this.$emit('discard-modal');
    },
    // reset input fields
    reset() {
      if (this.input == null) {
        this.obj = {
          id: '',
          outletCode: '',
          menuGroupCode: '',
          sequence: 0,
          qdoDisplay: true
        };
      } else {
        this.obj = this.input;
      }
    }
  }
};
</script>
